// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1RaftCheckMemberStatusString = {
  RaftCheckReplicating: 'REPLICATING',
  RaftCheckApplying: 'APPLYING',
  RaftCheckUnavailable: 'UNAVAILABLE',
  RaftCheckOldUnknown: 'UNKNOWN_MESSAGE',
} as const;
export type V1RaftCheckMemberStatusString =
  (typeof V1RaftCheckMemberStatusString)[keyof typeof V1RaftCheckMemberStatusString];

export function instanceOfV1RaftCheckMemberStatusString(value: any): boolean {
  for (const key in V1RaftCheckMemberStatusString) {
    if (
      Object.prototype.hasOwnProperty.call(V1RaftCheckMemberStatusString, key)
    ) {
      if (
        V1RaftCheckMemberStatusString[
          key as keyof typeof V1RaftCheckMemberStatusString
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1RaftCheckMemberStatusStringFromJSON(
  json: any,
): V1RaftCheckMemberStatusString {
  return V1RaftCheckMemberStatusStringFromJSONTyped(json, false);
}

export function V1RaftCheckMemberStatusStringFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1RaftCheckMemberStatusString {
  return json as V1RaftCheckMemberStatusString;
}

export function V1RaftCheckMemberStatusStringToJSON(
  value?: V1RaftCheckMemberStatusString | null,
): any {
  return value as any;
}

export function V1RaftCheckMemberStatusStringToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1RaftCheckMemberStatusString {
  return value as V1RaftCheckMemberStatusString;
}
